// Файл slice.js

/**
 * Модуль обслуживает сценарий `slice` в разделе `redux`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

import { createSlice } from '@reduxjs/toolkit';



const appSlice = createSlice({
    name: 'app',
    initialState: {
        serviceId: null,
        windows: {
            add_resident: false,
            addServiceWindow: false,
            addCountersWindow: false,
            serviceWindow: false,
            share_window: false,
        },
        windowData: null,
    },
    reducers: {
        setServiceId: (state, action) => {
            state.serviceId = action.payload;
        },

        openWindow: (state, action) => {
            const { windowId, data } = action.payload;
            state.windows[windowId] = true;

            if (data) {
                state.windowData = data;
            }
        },

        closeWindow: (state, action) => {
            state.windows[action.payload] = false;
            state.windowData = null;
        },

        setWindows: (state, action) => {
            state.windows = action.payload;
        },
    },
});


export const {
    setServiceId,
    openWindow,
    closeWindow,
    setWindows,
} = appSlice.actions;


export default appSlice.reducer;
